import { render, staticRenderFns } from "./eDocumentDetails.vue?vue&type=template&id=25334623&scoped=true"
import script from "./eDocumentDetails.vue?vue&type=script&lang=js"
export * from "./eDocumentDetails.vue?vue&type=script&lang=js"
import style0 from "./eDocumentDetails.vue?vue&type=style&index=0&id=25334623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25334623",
  null
  
)

export default component.exports